import type { SourcingEventDto } from "../../../autogen/bff-api";
import type { BidSubject } from "../../../common/terminology/bidSubjectTerms";
import { eventIsDesignContest } from "../../sourcing-events/buyer/wizard/utils/designContest";

export const bidSubjectOf = (event: SourcingEventDto): BidSubject => {
  if (!eventIsDesignContest(event)) return "supplier";
  return event.entriesAnonymous ? "entry" : "participant";
};

// t('{{resolved}} of {{total}} suppliers qualified or rejected')
// t('{{resolved}} of {{total}} entries qualified or rejected')
// t('{{resolved}} of {{total}} participants qualified or rejected')
const PROGRESS_KEYS: Record<BidSubject, string> = {
  supplier: "{{resolved}} of {{total}} suppliers qualified or rejected",
  entry: "{{resolved}} of {{total}} entries qualified or rejected",
  participant: "{{resolved}} of {{total}} participants qualified or rejected",
};

export const qualificationProgressKey = (event: SourcingEventDto): string => PROGRESS_KEYS[bidSubjectOf(event)];
